<template>
    <div v-if="planningItem !== null">
        <div class="header-grid">
            <div class="grid-item">
                <md-button @click="goBack()" id="back-btn" style="padding: 0px; margin: 0px">
                    <md-icon>keyboard_arrow_left</md-icon>
                    back
                </md-button>
            </div>
            <div class="grid-item" style="margin-left: auto">
                <div class="md-layout-item md-small-size-20">
                    <!--          <md-button class="md-icon-button pointer md-raised md-mini">-->
                    <!--            <label for="planning-item-picture"><md-icon>add_a_photo</md-icon></label>-->
                    <!--          </md-button>-->
                    <label
                        class="picture-button md-icon-button"
                        :class="{ 'is-loading': isUploading }"
                        for="planning-item-picture"
                        title="Foto’s toevoegen"
                    >
                        <md-icon v-if="!isUploading">add_a_photo</md-icon>
                        <md-progress-spinner v-else md-mode="indeterminate" :md-diameter="15" />
                    </label>
                    <input
                        ref="pictureInput"
                        id="planning-item-picture"
                        accept="image/x-png,image/jpeg,image/gif"
                        name="file_to_upload"
                        style="opacity: 0; position: absolute; left: 0; z-index: -1"
                        type="file"
                        multiple
                        @change="uploadPictures()"
                    />
                    <!-- onChange={() => this.upload()} -->
                </div>
            </div>
        </div>

        <div>
            <div class="md-layout" style="text-align: center">
                <div class="md-headline md-layout-item">
                    {{ planningType }} - {{ planningItem.planning_item_type_number }}
                </div>
            </div>

            <md-tabs md-sync-route md-swipebale="true">
                <template slot="md-tab" slot-scope="{ tab }">
                    <md-icon>{{ tab.data.icon }}</md-icon>

                    <i class="badge md-primary" v-if="tab.data.badge">{{ tab.data.badge }}</i>
                </template>
                <md-tab
                    :to="`${openedPath}/planning-item`"
                    exact
                    id="tab-detail"
                    md-label="Details"
                    :md-template-data="{ icon: 'info' }"
                >
                    <planning-detail-planning-item-view />
                </md-tab>

                <md-tab
                    :to="`${openedPath}/visit-report`"
                    id="tab-visit-report"
                    :md-template-data="{
                        icon: 'description',
                        badge: planningItem.visit_reports ? planningItem.visit_reports.length : 0,
                    }"
                    md-label="Visit reports"
                >
                    <planning-detail-visit-reports-view />
                </md-tab>

                <md-tab
                    :to="`${openedPath}/comment`"
                    id="tab-comments"
                    :md-template-data="{
                        icon: 'chat',
                        badge: planningItem.comments ? planningItem.comments.length : 0,
                    }"
                    md-label="Comments"
                >
                    <planning-detail-comments-view />
                </md-tab>

                <md-tab
                    :to="`${openedPath}/dossier`"
                    id="tab-dossier"
                    :md-template-data="{ icon: 'folder', badge: dossierCount }"
                    md-label="Dossier"
                >
                    <planning-detail-dossier-view />
                </md-tab>
            </md-tabs>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PlanningParameters } from '@/services/manager/planning.manager';
import PlanningCard from '@/components/PlanningCard.vue';
import router from '@/router';
import PlanningDetailPlanningItemView from '@/views/planning/planning-detail-tabs/PlanningDetailPlanningItemView.vue';
import PlanningDetailVisitReportsView from '@/views/planning/planning-detail-tabs/PlanningDetailVisitReportsView.vue';
import PlanningDetailCommentsView from '@/views/planning/planning-detail-tabs/PlanningDetailCommentsView.vue';
import PlanningDetailDossierView from '@/views/planning/planning-detail-tabs/PlanningDetailDossierView.vue';
import { uploadPlanningItemAttachment } from '@/resources/phrospr-api/planning-item.service';
import * as toastr from 'toastr';
import {
    IConfiguration,
    IPlanningItemEntity,
    IQuoteEntity,
    IWorkOrderEntity,
    PlanningItemType,
} from '@phrospr/lib-models';

@Component({
    components: {
        PlanningDetailCommentsView,
        PlanningDetailVisitReportsView,
        PlanningDetailPlanningItemView,
        PlanningCard,
        PlanningDetailDossierView,
    },
})
export default class PlanningDetailView extends Vue {
    public PlanningItemType = PlanningItemType;
    @Prop() private calendarItemId: number;

    openedPath: string;
    isUploading = false;

    constructor() {
        super();
        this.openedPath = router.currentRoute.path.replace(/detail.*/, 'detail');
        this.loadPlanningItem();
    }

    get planningType() {
        return this.planningItem.planning_item_type.toUpperCase();
    }

    get planningItem(): IPlanningItemEntity {
        return this.$store.state.planningItem;
    }

    get quotes(): IQuoteEntity[] {
        return this.$store.state.quotes;
    }

    get workOrders(): IWorkOrderEntity[] {
        return this.$store.state.workOrders;
    }

    get configuration(): Partial<IConfiguration> {
        return this.$store.state.configuration;
    }

    // Mirrors the Dossier tab's section visibility, otherwise stale store data
    // from a previously opened planning item would show a phantom badge count.
    get dossierCount(): number {
        const attachments = this.planningItem.attachments ? this.planningItem.attachments.length : 0;
        const showQuotes =
            this.planningItem.planning_item_type === PlanningItemType.lead ||
            this.planningItem.planning_item_type === PlanningItemType.placement;
        const quotes = showQuotes && this.quotes ? this.quotes.length : 0;
        const showWorkOrders = this.configuration?.workOrders?.enabled === true;
        const workOrders = showWorkOrders && this.workOrders ? this.workOrders.length : 0;
        return attachments + quotes + workOrders;
    }

    public goBack() {
        PlanningParameters.listDate = new Date(this.planningItem.selected_calendar_item.date_time_start);
        this.$store.commit('resetPlanningItem');
        router.push('/planning');
    }

    private async uploadPictures() {
        this.isUploading = true;
        try {
            const input = this.$refs.pictureInput as HTMLInputElement;

            if (!input?.files?.length) {
                console.log('no files selected');
                return;
            }

            const files = Array.from(input.files);

            let uploadedCount = 0;
            for (const file of files) {
                if (file.size > 10485760) {
                    toastr.error(`"${file.name}" is te groot (max. 10Mb)`);
                    continue;
                }

                try {
                    await uploadPlanningItemAttachment(this.planningItem.planning_item_id, this.calendarItemId, file);
                    uploadedCount++;
                } catch (error) {
                    toastr.error(`Opslaan van "${file.name}" is mislukt`);
                    console.error(error);
                }
            }

            if (uploadedCount > 0) {
                toastr.success(`${uploadedCount} foto(’s) opgeslagen!`);
                await this.$store.dispatch('refreshPlanningItem');
            }

            // reset input so same files can be selected again
            input.value = '';
        } catch (error) {
            toastr.error('Er is iets misgegaan tijdens het opslaan van de foto’s');
            console.error(error);
        } finally {
            this.isUploading = false;
        }
    }

    private async loadPlanningItem() {
        try {
            // clear leftovers of a previously opened planning item
            this.$store.commit('resetQuotes');
            this.$store.commit('resetWorkOrders');
            await this.$store.dispatch('getPlanningDetailFromCalendarItemId', this.calendarItemId);
            if (this.planningItem.planning_item_type === PlanningItemType.lead || this.planningItem.lead_id) {
                await this.$store.dispatch('getQuotesFromPlanningItemForLeadId', this.planningItem.planning_item_id);
            } else if (this.planningItem.planning_item_type === PlanningItemType.placement) {
                await this.$store.dispatch('getQuotesFromPlanningItemID', this.planningItem.planning_item_id);
            }
            if (this.configuration?.workOrders?.enabled === true) {
                await this.$store.dispatch('getWorkOrdersFromPlanningItem', this.planningItem.planning_item_id);
            }
        } catch (err) {
            console.log(err);
        }
    }
}
</script>

<style scoped>
#back-btn {
    /*float: right;*/
}

.comment-button {
    text-align: right;
}

.md-button[disabled] {
    opacity: 0.5;
}

.picture-button {
    width: 40px;
    padding-left: 7px;
    padding-top: 5px;
    justify-content: center;
    align-items: center;
    display: inline-block;
    background: #dddddd;
    cursor: pointer;
}

.picture-button:hover {
    background: #888888;
}

.picture-button:active {
    background: #555555;
}

#tab-visit-report {
    padding: 0;
    padding-top: 5px;
    padding-bottom: 5px;
}

.badge {
    width: 19px;
    height: 17px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 1px;
    right: 2px;
    background: #e69138;
    border-radius: 100%;
    color: #fff;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.05em;
    font-family: 'Roboto Mono', monospace;
}

.header-grid {
    display: grid;
    grid-template-columns: 80% 20%;
}

.grid-item {
    display: inline-block;
}
</style>
